import { gql } from '@apollo/client'
import employeeDisplayShortInfoFragment from '../employee/fragments/employeeDisplayShortInfo.fragment'
import meetingCoreFragment from './fragments/meetingCore.fragment'
import meetingDashboardFragment from './fragments/meetingDashboard.fragment'
import employeeDisplayFragment from '../employee/fragments/employeeDisplay.fragment'

export const MEETINGS_BY_MANAGER = gql`
  query MeetingsByManager($managerId: HashedId!, $disputedMeetingsIncluded: Boolean = false) {
    meetingsByManager(managerId: $managerId, disputedMeetingsIncluded: $disputedMeetingsIncluded) {
      ...MeetingDashboard
      isLoggedUserCompanyManagerOfAppraisalSeasonCompany
      isReplyerActive
    }
  }
  ${meetingDashboardFragment}
`

export const SUBORDINATE_MEETINGS = gql`
  query SubordinateMeetings($managerId: HashedId!) {
    subordinateMeetings(managerId: $managerId) {
      ...MeetingDashboard
      isLoggedUserCompanyManagerOfAppraisalSeasonCompany
    }
  }
  ${meetingDashboardFragment}
`

export const MEETINGS_BY_REPLYER = gql`
  query MeetingsByReplyer($replyerId: HashedId!, $disputedMeetingsIncluded: Boolean = false) {
    meetingsByReplyer(replyerId: $replyerId, disputedMeetingsIncluded: $disputedMeetingsIncluded) {
      ...MeetingDashboard
    }
  }
  ${meetingDashboardFragment}
`

export const MEETINGS_HISTORY_BY_REPLYER = gql`
  query MeetingsHistoryByReplyer($replyerId: HashedId!, $isResigned: Boolean) {
    meetingsHistoryByReplyer(replyerId: $replyerId, isResigned: $isResigned) {
      ...MeetingCore
      confirmationDate
      reviewer {
        ...EmployeeDisplayShortInfo
      }
      employee {
        ...EmployeeDisplay
      }
      forceConfirmationEmployee {
        ...EmployeeDisplayShortInfo
      }
      forceConfirmationReason
      employeePrepared
      preparationPdfFileName
      preparationPdfDownloadToken
      conclusionPdfFileName
      conclusionPdfDownloadToken
      appraisalSeason {
        id
        companyId
        country
        year
        fromDate
        toDate
      }
    }
  }
  ${meetingCoreFragment}
  ${employeeDisplayShortInfoFragment}
  ${employeeDisplayFragment}
  ${employeeDisplayShortInfoFragment}
`

export const INVITE_APPRAISAL = gql`
  mutation InviteToAppraisalMeeting($meetingInput: MeetingInviteInput!) {
    inviteToAppraisalMeeting(meetingInput: $meetingInput) {
      ...MeetingDashboard
    }
  }
  ${meetingDashboardFragment}
`

export const CREATE_OTHER_MEETING_INVITE = gql`
  mutation CreateOtherMeetingInvite($meetingInput: MeetingInviteInput!) {
    otherMeetingInvite(meetingInput: $meetingInput) {
      ...MeetingDashboard
    }
  }
  ${meetingDashboardFragment}
`
